import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import type { TopBarProps } from "@/ui/organisms/TopBar";
import TopBar from "@/ui/organisms/TopBar";
import React from "react";

export type LayoutFullScreenProps = BoxProps & {
    hideTopBar?: boolean;
    TopBarProps?: TopBarProps;
    MainContentProps?: BoxProps;
    contentTopBar?: TopBarProps["children"];
    contentTopBarBanner?: React.ReactNode;
    contentSidebar?: React.ReactNode;
};

export const testId = "LayoutFullScreen";
const LayoutFullScreen = (props: LayoutFullScreenProps) => {
    const {
        sx,
        hideTopBar = false,
        children,
        contentTopBar,
        contentTopBarBanner,
        TopBarProps,
        MainContentProps,
        contentSidebar,
        ...otherProps
    } = props;

    return (
        <Box
            data-testid={testId}
            className={testId}
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                ...sx,
            }}
            {...otherProps}
        >
            {!hideTopBar && (
                <Box
                    sx={{
                        flexShrink: 0,
                    }}
                >
                    <TopBar slotBanner={contentTopBarBanner} {...TopBarProps}>
                        {contentTopBar}
                    </TopBar>
                </Box>
            )}
            <Box
                sx={{
                    display: "flex",
                    flexGrow: 1,
                    minHeight: 0,
                    overflowX: "hidden",
                    width: "100%",
                }}
            >
                {contentSidebar !== undefined && (
                    <div style={{ borderTop: "1px solid var(--proda-black)" }}>
                        {contentSidebar}
                    </div>
                )}
                <Box
                    {...MainContentProps}
                    sx={{
                        overflowY: "auto",
                        backgroundColor: "var(--primary-color)",
                        position: "relative",
                        flexGrow: 1,
                        ...MainContentProps?.sx,
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default LayoutFullScreen;
